import React from "react";
import cn from "classnames";
import Loadable from "@loadable/component";
import { Link } from "gatsby";

const OwlCarousel = Loadable(() => import("react-owl-carousel3"));

/**
 *
 * @param {object} props
 * @param {string} props.title
 * @param {string[]} props.descriptions
 * @param {string | string[]} props.images
 * @param {boolean} props.reverse
 * @param {string} props.className
 */
const FeatureBox = props => {
  const { title, descriptions, images, reverse, className } = props;
  let images2 = images;
  if (typeof images2 === "string") {
    images2 = [images2];
  }
  const options = {
    loop: true,
    nav: false,
    dots: false,
    autoplaySpeed: 2000,
    autoplayHoverPause: true,
    autoplay: true,
    items: 1,
    callbacks: true,
  };
  const renderImages = () => {
    return (
      <div className="col-lg-5 col-md-12">
        <div className="image">
          <OwlCarousel {...options} mouseDrag={images2.length > 1} touchDrag={images2.length > 1} className="testimonials-slides owl-carousel owl-theme shadow rounded">
            {images2.map((image2, key) => (
              <img key={`img-${key + 1}`} src={image2} className="img-fluid rounded" alt={title} />
            ))}
          </OwlCarousel>
        </div>
      </div>
    );
  };
  return (
    <div className={cn("row", "align-items-center", className)}>
      {!reverse && renderImages()}
      <div className="col-lg-7 col-md-12">
        <div className="blog-details-desc">
          <div className="content article-content">
            <h3>{title}</h3>
            <ul className="features-list">
              {descriptions.map((desc, key) => (
                <li key={`li-${key + 1}`}>
                  <i className="bx bx-badge-check"></i>
                  {desc}
                </li>
              ))}
            </ul>
            <div className="w-100 text-right">
              <Link to="/reservation" className="default-btn" style={{ padding: "7px 14px 7px 40px" }}>
                <i className="flaticon-web" style={{ left: 15 }}></i>
                免费试用
                <span></span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {reverse && renderImages()}
    </div>
  );
};

export default FeatureBox;
